import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <>
      <Helmet>
        <title>Sobre | AICD</title>
      </Helmet>
      <div className="space-y-6">
        <header className="space-y-3">
          <Link
            to="/profile"
            aria-label="Voltar ao perfil"
            className="inline-flex items-center gap-1 text-sm font-semibold text-muted-foreground hover:text-foreground"
          >
            <BackGlyph />
            Voltar
          </Link>
          <div>
            <h1 className="text-2xl font-black text-foreground">
              Sobre o <span className="text-primary">DIGGER</span>{' '}
              <span className="text-secondary">CDI</span>
            </h1>
            <p className="mt-1 subtitle text-sm text-muted-foreground">
              Laboratórios Inovação Social com Tecnologia.
            </p>
          </div>
        </header>

        <div className="card p-6">
          <p className="text-sm leading-relaxed text-foreground">
            O DIGGER CDI é a aplicação de acesso e reserva de equipamento dos Centros
            Digitais de Informação. Encontre equipamento no seu Centro, reserve uma
            faixa horária e termine a visita quando concluir — tudo no mesmo sítio.
          </p>

          <div className="mt-5 grid grid-cols-2 gap-3 text-xs">
            <div>
              <p className="section-eyebrow">Versão</p>
              <p className="mt-1 font-bold text-foreground">1.0.0</p>
            </div>
            <div>
              <p className="section-eyebrow">Desenvolvido para</p>
              <p className="mt-1 font-bold text-foreground">AICD</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function BackGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2.5}>
      <path d="M15 18l-6-6 6-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
